import { render, staticRenderFns } from "./BugReports.vue?vue&type=template&id=19367a38&scoped=true"
import script from "./BugReports.vue?vue&type=script&lang=js"
export * from "./BugReports.vue?vue&type=script&lang=js"
import style0 from "./BugReports.vue?vue&type=style&index=0&id=19367a38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19367a38",
  null
  
)

export default component.exports